import React from "react";
import is_upcoming from "../../utils/upcoming";
import ListingItem from "../ListingItem";

class TagListing extends React.Component {
  render() {
    let data = this.props.data;
    let upcoming = [];
    let past = [];
    let slug = this.props.pageContext.slug;
    slug = slug.split("/");

    slug = slug.length >= 2 ? slug[2] : slug[1];

    if (data !== null) {
      upcoming = data.edges
        .filter(
          (node) =>
            is_upcoming(node.node.frontmatter.date) &&
            node.node.frontmatter.ongoing === null &&
            slug.includes(node.node.frontmatter.parent) &&
            this.props.pageContext.slug !== node.node.fields.slug
        )
        .reverse();
      past = data.edges.filter(
        (node) =>
          !is_upcoming(node.node.frontmatter.date) &&
          slug.includes(node.node.frontmatter.parent) &&
          this.props.pageContext.slug !== node.node.fields.slug
      );
    }

    return (
      <div
        className={
          "tags-listing" +
          (upcoming.length ? "" : " no-upcoming") +
          (past.length ? "" : " no-past")
        }
      >
        <div className="tags-section-wrap upcoming">
          {upcoming.length > 0 && (
            <div className="tags-section upcoming">Upcoming</div>
          )}
          <div className="tags-listing-wrap">
            {upcoming.map(({ node }) => {
              return <ListingItem key={node.id} node={node} />;
            })}
          </div>
        </div>

        <div className="tags-section-wrap past">
          {past.length > 0 && <div className="tags-section upcoming">Past</div>}
          <div className="tags-listing-wrap">
            {past.map(({ node }) => {
              return <ListingItem key={node.id} node={node} past />;
            })}
          </div>
        </div>
      </div>
    );
  }
}

export default TagListing;
